import * as React from "react";
import { Component } from "react";

interface BackgrondLayerProps {
    color?: string;
    opacity?: number;
    zIndex?: number;
    onClickCallback?: () => void;
}

export default class BackgroundLayer extends Component<BackgrondLayerProps> {
    render() {
        return (
            <div
                style={{
                    height: "100%",
                    width: "100%",
                    position: "absolute",
                    backgroundColor: this.props.color,
                    opacity: this.props.opacity,
                    zIndex: this.props.zIndex,
                }}
                onClick={this.props.onClickCallback}
            ></div>
        );
    }
}
